export default __webpack_public_path__ + "static/media/material-ui-1.fd510ed8.svg";